/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-04 11:12:46
 * @LastEditors: sj
 * @LastEditTime: 2022-05-23 10:47:06
 */
import { Button, Col } from 'antd'
import React, { ReactElement, useContext, useRef, useState } from 'react'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { ThemeContext } from '../../theme/ThemeContext'
import { ReplaceMakeDrugDetail } from './components/detail/ReplaceMakeDrugDetail'
import { ReplaceMakeOrder } from './components/order/ReplaceMakeOrder'
import Statistics from './components/statistics/Statistics'

export const StatisticAnalysisNavBar = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const exRef = useRef<any>(null)

  return (
    <Col
      style={{
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'hidden',
      }}
    >
      <TabBar style={{ margin: '10px 20px' }}>
        <TabPane key='0' tab='代煎订单'>
          <ReplaceMakeOrder />
        </TabPane>
        {/* <TabPane key='1' tab='代煎药品明细'>
          <ReplaceMakeDrugDetail />
        </TabPane> */}
        <TabPane key='2' tab='数据统计'>
            <Statistics />
        </TabPane>
      </TabBar>
    </Col>
  )
}
